import type { FC } from 'react';
import { QIconButton } from '../../../QAtoms';
import { useQPropertiesPanelStateContext } from '../context';
import { useLibraryTranslation } from '../../../i18n';

/**
 * A button specially for openning the properties panel.
 * Hides itself when the properties panel is already open.
 */
export const QOpenPropertiesPanelButton: FC = () => {
  const { t } = useLibraryTranslation();
  const {
    disclosure: { isOpen, onOpen },
  } = useQPropertiesPanelStateContext();
  return isOpen ? null : (
    <QIconButton
      iconName="ChevronsLeft"
      aria-label={t('propertiesPanel.open')}
      onClick={onOpen}
    />
  );
};
